import React from "react";
import styled, { css } from "styled-components";
import { Typography } from "../Typography";

type TabItem = {
	id: string;
	label: string;
};

type TabsProps = {
	items: TabItem[];
	activeTab: string;
	onTabChange: (tabId: string) => void;
};

const TabsContainer = styled.div`
	display: flex;
	border-bottom: 1px solid #242424;
`;

const TabItem = styled.button<{ $isActive: boolean }>`
	padding: 1rem 1.25rem;
	background: none;
	border: none;
	cursor: pointer;
	position: relative;
	white-space: nowrap;

	${({ $isActive }) =>
		$isActive &&
		css`
			background: linear-gradient(
				180deg,
				rgba(3, 255, 143, 0) 0%,
				#1e1e1e 766.96%
			);
		`}
`;

export const Tabs: React.FC<TabsProps> = ({
	items,
	activeTab,
	onTabChange,
}) => {
	return (
		<TabsContainer>
			{items.map((item) => (
				<TabItem
					key={item.id}
					$isActive={item.id === activeTab}
					onClick={() => onTabChange(item.id)}
				>
					<Typography
						variant="p"
						color={
							item.id === activeTab ? "var(--primary)" : "var(--on-surface)"
						}
					>
						{item.label}
					</Typography>
				</TabItem>
			))}
		</TabsContainer>
	);
};
